import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import * as Constants from '../../common/constants';
const useStyles = makeStyles((theme) => createStyles({
    appBar: {
        backgroundColor: '#000',
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${Constants.DRAWER_WIDTH}px)`,
            marginLeft: Constants.DRAWER_WIDTH,
        },
    },
    backButton: {
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: '#eee',
        },
    },
    // メニュー開閉ボタンはmobileのみ表示
    menuButton: {
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
}));
export const BarWithMenuIcon = (props) => {
    const { onClickIcon } = props;
    const classes = useStyles();
    const history = useHistory();
    const onClickBack = () => history.goBack();
    return (React.createElement(AppBar, { position: "static", className: classes.appBar },
        React.createElement(SToolBar, null,
            React.createElement(IconButton, { color: "default", size: "small", onClick: onClickBack, className: classes.backButton },
                React.createElement(NavigateBeforeIcon, null)),
            React.createElement(IconButton, { color: "inherit", onClick: onClickIcon, className: classes.menuButton },
                React.createElement(MenuIcon, null)))));
};
const SToolBar = styled(Toolbar) `
  display: flex;
  justify-content: space-between;
`;
